export function applyTo(IDSelector) {
    let backToTop = document.getElementById(IDSelector);

    if(backToTop) {
        backToTop.onclick = function (e) {
            console.log('333');
            e.preventDefault();

            let startTop = document.documentElement.scrollTop || document.body.scrollTop;

            let animationLength = 300;
            let step = Math.round(startTop/(animationLength/2));

            let timeout = setInterval(function() {
                startTop = Math.max(0, startTop - step);
                window.scrollTo(0, startTop);

                if(startTop <= 0) {
                    clearInterval(timeout);
                }
            }, 2);

        };
    }
}
